import { useState } from "react";
import ProductsContext from "../context/productsContext";
import Product from "../../entities/Product";

const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);

  function getProducts(data) {
    const prods = [];

    data?.forEach((prod) => {
      prods.push(new Product(prod));
    });

    //sort products by creation date before storing them in the state
    prods.sort((a, b) => Number(b.getCreationDate) - Number(a.getCreationDate));

    setProducts(prods);
  }

  function getOneProduct(id) {
    const product = products.find((p) => p.getId === id);

    return product;
  }

  const contextValue = {
    products,
    getProducts,
    getOneProduct,
  };

  return (
    <ProductsContext.Provider value={contextValue}>
      {children}
    </ProductsContext.Provider>
  );
};

export default ProductProvider;
